import { FC, CSSProperties } from 'react';

export const ArrowUpload: FC<{ className?: string; style?: CSSProperties }> = ({ className, style }) => {
  return (
    <span className={className} style={style}>
      <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M7.11306 0.801278C7.69885 0.215492 8.6486 0.215492 9.23438 0.801278L14.9447 6.51162C15.5305 7.09741 15.5305 8.04716 14.9447 8.63294C14.3589 9.21873 13.4092 9.21873 12.8234 8.63294L9.67372 5.48326V15.424C9.67372 16.2524 9.00215 16.924 8.17372 16.924C7.3453 16.924 6.67372 16.2524 6.67372 15.424V5.48326L3.52404 8.63294C2.93825 9.21873 1.98851 9.21873 1.40272 8.63294C0.816932 8.04716 0.816932 7.09741 1.40272 6.51162L7.11306 0.801278Z"
          fill="#2D11AD"
        />
      </svg>
    </span>
  );
};
